import React from 'react'
import { Badge } from '@astryxdesign/core/Badge'
import { TextArea } from '@astryxdesign/core/TextArea'

export const MIN_STORY_BLURB_LENGTH = 50
export const MAX_STORY_BLURB_LENGTH = 1200

interface StoryBlurbFieldProps {
  value: string
  onChange: (value: string) => void
  description: string
  placeholder?: string
  rows?: number
  isDisabled?: boolean
  isRequired?: boolean
}

export default function StoryBlurbField({
  value,
  onChange,
  description,
  placeholder = 'Describe the premise without revealing what happens…',
  rows = 5,
  isDisabled = false,
  isRequired = true
}: StoryBlurbFieldProps): React.JSX.Element {
  const isInvalid = value.trim().length > 0 && value.trim().length < MIN_STORY_BLURB_LENGTH

  return (
    <section className={`story-blurb-field${isInvalid ? ' story-blurb-field--invalid' : ''}`}>
      <TextArea
        label="Story blurb"
        description={description}
        value={value}
        onChange={(nextValue) => onChange(nextValue.slice(0, MAX_STORY_BLURB_LENGTH))}
        placeholder={placeholder}
        rows={rows}
        isDisabled={isDisabled}
        isRequired={isRequired}
        status={
          isInvalid
            ? {
                type: 'error',
                message: `Enter at least ${MIN_STORY_BLURB_LENGTH} characters.`
              }
            : undefined
        }
      />
      <span className="story-blurb-character-count" aria-live="polite">
        <Badge label={`${value.length}/${MAX_STORY_BLURB_LENGTH}`} />
      </span>
    </section>
  )
}
